

















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
import version from "@/version";

import { mapGetters } from "vuex";
//  引入ts 的表格数据
import activityData from "../data/activityData";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue
    }
})
export default class BusinessActivity extends Vue {
    // 下载
    downLoad() {
        let url = `${Vue.axios.defaults.baseURL}export/activity?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period}&version=${version}&token=${this.$store.state.account.token}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }
    // 07 13 准则表格数据
    dataList: activityData[] = activityData.list;
    //改变时间
    period: String[] = []; // 日期
    changeDate(date: string[]) {
        this.period = date;
        this.fetchData();
    }
    // 获取表格数据
    fetchData() {
        Vue.axios
            .post(`profits/find`, {
                accountBookId: this.$store.state.accountBook.id,
                endPeriod: this.period
            })
            .then(res => {
                for (let i = 0; i < this.dataList.length; i++) {
                    if (res.data.monthUnLimit) {
                        this.dataList[i].monthUnLimit =
                            res.data.monthUnLimit[i];
                        this.dataList[i].monthLimit =
                            res.data.monthLimit[i];
                        this.dataList[i].monthSum =
                            res.data.monthSum[i];
                        this.dataList[i].yearUnLimit =
                            res.data.yearUnLimit[i];
                        this.dataList[i].yearLimit =
                            res.data.yearLimit[i];
                        this.dataList[i].yearSum =
                            res.data.yearSum[i];
                    }
                }
            });
    }
}
